import React, { useEffect, useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';

const AuthCallback = () => {
  const navigate = useNavigate();
  const hasProcessed = useRef(false);
  const [error, setError] = useState(null);
  
  useEffect(() => {
    // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
    if (hasProcessed.current) return;
    hasProcessed.current = true;
    
    const processSession = async () => {
      try {
        // Extract session_id from URL fragment
        const hash = window.location.hash;
        console.log('Auth callback - URL hash:', hash);
        
        const params = new URLSearchParams(hash.substring(1));
        const sessionId = params.get('session_id');
        
        if (!sessionId) {
          console.error('No session_id found in URL');
          setError('No session ID found. Please try logging in again.');
          setTimeout(() => navigate('/login'), 2000);
          return;
        }
        
        // Use relative URL so it works on any domain (preview or custom)
        console.log('Auth callback - Making session request (relative URL)');
        
        const response = await axios.post(
          `/api/auth/session`,
          {},
          {
            headers: {
              'X-Session-ID': sessionId,
              'Content-Type': 'application/json'
            },
            timeout: 15000
          }
        );
        
        console.log('Auth callback - Session response received:', response.status);
        
        // Store session token in localStorage for cross-domain support
        if (response.data.session_token) {
          localStorage.setItem('session_token', response.data.session_token);
          console.log('Auth callback - Token stored in localStorage');
        }
        
        // Store user data for immediate access
        const userData = response.data.user || response.data;
        localStorage.setItem('user_data', JSON.stringify(userData));
        console.log('Auth callback - User data stored, navigating to dashboard');
        
        // Navigate to dashboard with user data
        navigate('/dashboard', { 
          state: { user: userData },
          replace: true 
        });
      } catch (error) {
        console.error('Error processing session:', error);
        console.error('Error details:', {
          message: error.message,
          response: error.response?.data,
          status: error.response?.status
        });
        
        // Show user-friendly error
        if (error.response?.status === 401) {
          setError('Session expired. Please try logging in again.');
        } else if (error.code === 'ERR_NETWORK') {
          setError('Network error. Please check your connection and try again.');
        } else {
          setError('Authentication failed. Please try again.');
        }
        
        setTimeout(() => navigate('/login'), 2000);
      }
    };
    
    processSession();
  }, [navigate]);
  
  return (
    <div className="min-h-screen flex items-center justify-center bg-background">
      <div className="text-center">
        {error ? (
          <>
            <div className="text-red-500 text-xl mb-4">⚠️</div>
            <p className="text-red-400 mb-2">{error}</p>
            <p className="text-muted-foreground text-sm">Redirecting to login...</p>
          </>
        ) : (
          <>
            <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-primary mx-auto mb-4"></div>
            <p className="text-foreground">Completing sign in...</p>
          </>
        )}
      </div>
    </div>
  );
};

export default AuthCallback;